import { ReactNode, useMemo } from 'react';
import { List } from '@phosphor-icons/react';
import { useViewportWidth } from 'client/hooks/useViewportWidth';
import { Button } from 'client/components/Button';
import { DropdownMenuItemProps, DropdownMenuProps } from 'client/components/DropdownMenu';
import { DropdownMenu } from 'client/components/DropdownMenu';
import { breakPoint } from 'client/Theme';

export type OverflowMenuItemProps = Omit<DropdownMenuItemProps, 'onSelect' | 'onClick'> & {
  hidden?: boolean;
  visibleElement?: (props: OverflowMenuItemProps) => ReactNode;
  onClick?: () => void;
};

export interface OverflowMenuProps extends Omit<DropdownMenuProps, 'items' | 'onSelect'> {
  items: OverflowMenuItemProps[];
}

export const OverflowMenu = ({ items }: OverflowMenuProps) => {
  const viewportWidth = useViewportWidth();

  const visibleElements = useMemo(
    () => items.filter((item) => !item.hidden).map((item) => (item.visibleElement ? item.visibleElement(item) : null)),
    [items]
  );

  // TODO: This could be calculated from menu width
  if (viewportWidth > breakPoint.medium) return <>{visibleElements}</>;

  return (
    <DropdownMenu items={items}>
      <Button icon={<List />} />
    </DropdownMenu>
  );
};
